/** Shared QR menu / tent-card theme presets */
export const QR_MENU_THEMES = [
  {
    id: "warm_spice",
    label: "Warm spice",
    hint: "Clay orange · cream · charcoal",
  },
  {
    id: "charcoal_gold",
    label: "Charcoal & gold",
    hint: "Dark elegant · soft gold accents",
  },
  {
    id: "coastal",
    label: "Coastal",
    hint: "Sea blue · sand · white",
  },
  {
    id: "garden",
    label: "Garden",
    hint: "Olive · cream · terracotta",
  },
  {
    id: "classic_linen",
    label: "Classic linen",
    hint: "Ivory · ink · muted rust",
  },
];

export function qrMenuBrowseUrl(branchCode, origin = window.location.origin) {
  return `${origin}/menu/${encodeURIComponent(String(branchCode || "").toUpperCase())}`;
}

export function qrImageUrl(targetUrl, size = 220) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(targetUrl)}`;
}
